import { platform } from '@platform';

/** Hands a decrypted file to the viewer; how that happens is the platform's business. */
export function saveFile(filename: string, blob: Blob): Promise<void> {
  return platform.saveFile(filename, blob);
}
